import { Component, OnInit, OnDestroy } from '@angular/core';

import { ModalService } from '../../shared/modules/modal';
import { StudiesService, EntitiesService, NotificationService } from '../../shared/services';

import { ConfirmationModalComponent } from '../../shared/components/confirmation-modal/confirmation-modal.component';
import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';

import { Study, Entity, StudyValidationErrorResponse, StudyModalsPayload, Message } from '../../shared/models';

@Component({
  selector: 'study-modal',
  templateUrl: './study-modal.component.html',
})
export class StudyModalComponent
  extends ClosableModalWithErrorResponseModel<StudyValidationErrorResponse>
  implements OnInit, OnDestroy {

  data: StudyModalsPayload;
  study: Study;
  entities: Entity[] = [];
  lockedFields: string[] = [];

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _studiesService: StudiesService,
    private _entitiesService: EntitiesService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new StudyValidationErrorResponse();
  }

  ngOnInit(): void {
    this.study = new Study();
    this.getEntities();
    if (this.data && this.data.studyId > 0) {
      this.getStudy(this.data.studyId);
    }
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.responseErrors = [];
    if (!this.data) {
      this.create();
    } else {
      this.edit();
    }
  }

  close(form = null): void {
    if (form && form.form.touched) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: 'Close Study',
          content: 'Are you sure you want to cancel your actions and close it?',
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  private getStudy(studyId: number): void {
    this.responseErrors = [];
    this._studiesService.show(studyId).subscribe(({ data, locked }) => {
      this.study = data;
      this.lockedFields = locked;
    });
  }

  private create(): void {
    this._studiesService.save(this.study).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private edit(): void {
    this._studiesService.edit(this.data.studyId, this.study).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private getEntities() {
    const queryString = `?sort=code&order=asc`;
    this._entitiesService.list(queryString).subscribe(({ data }) => {
      this.entities = data;
    });
  }
}
